<template>
  <!--
          作者：luoyiming
          时间：2019-11-13
          描述：修改密码
      -->
  <el-dialog title="修改密码" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" width="30%">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="原始密码" :label-width="formLabelWidth" prop="oldPassword"
                    :rules="[{required: true,message: '请输入旧密码'}]">
        <el-input type="password" v-model="form.oldPassword" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPassword"
                    :rules="[{required: true,message: '请输入新密码'}]">
        <el-input type="password" v-model="form.newPassword" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" :label-width="formLabelWidth" prop="confirmPassword"
                    :rules="[{required: true,message: '请再次输入新密码'}]">
        <el-input type="password" v-model="form.confirmPassword" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitFunc(form.user_id)" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UserApi from '@/api/user.js';

export default {
  data() {
    return {
      loading: false,
      /*左边长度*/
      formLabelWidth: '100px',
      /*是否显示*/
      dialogVisible: true,
      /*表单*/
      form: {}
    };
  },
  props: [],
  created() {
  },
  methods: {
    /*确认事件*/
    submitFunc(e) {
      let self = this;
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          if (form.newPassword !== form.confirmPassword) {
            console.log(form.newPassword);
            console.log(form.confirmPassword);
            self.$message({
              message: '密码不一致',
              type: 'warning'
            });
            return
          }
          self.loading = true;
          UserApi.EditPass({oldPassword: form.oldPassword, newPassword: form.newPassword}, true).then(data => {
            self.loading = false;
            if (data.code === 1) {
              self.$message({
                message: data.data,
                type: 'success'
              });
              self.dialogFormVisible(true);
            } else {
              self.$message({
                message: data.data,
                type: 'error'
              });
              self.loading = false;
            }
          })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('close', false);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/layout/part/UpdatePassword.vue